import CheckBoxs from './CheckBoxs/CheckBoxs'
import Input from './Input/Input'
import SuccesBlock from './SuccesBlock/SuccesBlock'
import { styleForm } from './styleForm'
import { useForm } from './useForm'

const Form = () => {
    const {
        name,
        mail,
        phone,
        width,
        status,
        message,
        setMail,
        setName,
        mailError,
        setMessage,
        handleNext,
        handleChange,
        // phoneInputRef,
        isActiveButton,
        checkBoxPersonal,
        checkBoxBusiness,
        handleSubmitForm,
        phoneHandleChange,
        setCheckBoxBusiness,
        setCheckBoxPersonal,
        handleCheckBoxClick,
    } = useForm()
    const FirstPage = (
        <>
            <Input
                title={'Имя'}
                name={'name'}
                value={name}
                type={'text'}
                onChange={handleChange(setName)}
                placeholder={'Имя'}
                isDisabled={status === 'secondAnim'}
            />

            <Input
                title={'Телефон'}
                name={'phone'}
                value={phone}
                type={'phone'}
                // refInput={phoneInputRef}
                onChange={phoneHandleChange}
                placeholder={'+7-999-999-99-99'}
                isDisabled={status === 'secondAnim'}
            />

            <Input
                title={'Email'}
                name={'email'}
                error={mailError}
                value={mail}
                type={'email'}
                onChange={handleChange(setMail)}
                placeholder={'example@gmail.com'}
                isDisabled={status === 'secondAnim'}
            />
        </>
    )

    const SecondPage = (
        <>
            <InputTitleSC>Как бы вы использовали продукт?</InputTitleSC>
            <CheckBoxs
                checkBoxPersonal={checkBoxPersonal}
                checkBoxBusiness={checkBoxBusiness}
                handleCheckBoxClick={handleCheckBoxClick}
                setCheckBoxBusiness={setCheckBoxBusiness}
                setCheckBoxPersonal={setCheckBoxPersonal}
            />
            <InputTitleSC>Какие задачи вы бы хотели решить?</InputTitleSC>
            <TextAreaSC
                name='message'
                disabled={status === 'secondAnim'}
                onChange={handleChange(setMessage)}
                value={message}
                placeholder="Опишите, как вы планируете применить наше решение
                "
            />
        </>
    )

    return (
        <FormSC id="form">
            <MobileWrapperSC>
                <TitleSC
                    $color={width > 870 ? '#3C394B' : ' #FDFDFD'}
                    $marginBottomPX={'40px'}
                >
                    Заявка на бета-тест
                </TitleSC>
                <AnimationWrapperSC isAnimation={status}>
                    {status === 'first'
                        ? FirstPage
                        : status === 'second' || status === 'secondAnim'
                            ? SecondPage
                            : status === 'success' && <SuccesBlock />}
                </AnimationWrapperSC>
                {!(status === 'success') && (
                    <PageCountSC>
                        Шаг {status === 'first' ? '1/2' : '2/2'}
                    </PageCountSC>
                )}
            </MobileWrapperSC>
            {!(status === 'success') && (
                <SubmitButtonSC
                    type="button"
                    disabled={!isActiveButton}
                    isActive={isActiveButton}
                    onClick={(e) =>
                        status === 'first' ? handleNext(e) : handleSubmitForm(e)
                    }
                >
                    {status === 'first'
                        ? 'Далее'
                        : status === 'secondAnim'
                            ? 'Отправляем...'
                            : 'Отправить заявку'}
                </SubmitButtonSC>
            )}
        </FormSC>
    )
}

const {
    FormSC,
    TitleSC,
    TextAreaSC,
    PageCountSC,
    InputTitleSC,
    SubmitButtonSC,
    MobileWrapperSC,
    AnimationWrapperSC,
} = styleForm()

export default Form
